"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signFromLedger = void 0;
var proto_signing_1 = require("@cosmjs/proto-signing");
var tx_1 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
var long_1 = __importDefault(require("long"));
var math_1 = require("@cosmjs/math");
var encoding_1 = require("@cosmjs/encoding");
var aminotypes_1 = require("../amino/aminotypes");
var signdoc_1 = require("../amino/signdoc");
var encoding_2 = require("../amino/encoding");
var signdoc_2 = require("../amino/signdoc");
var encoding_3 = require("@cosmjs/encoding");
var signing_1 = require("cosmjs-types/cosmos/tx/signing/v1beta1/signing");
var tx_2 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
var FirmaUtil_1 = require("../../FirmaUtil");
function makeSignerInfos(signers, signMode) {
    return signers.map(function (_a) {
        var pubkey = _a.pubkey, sequence = _a.sequence;
        return ({
            publicKey: pubkey,
            modeInfo: {
                single: { mode: signMode },
            },
            sequence: long_1.default.fromNumber(sequence),
        });
    });
}
function makeAuthInfoBytes(signers, feeAmount, gasLimit, granter, signMode) {
    if (signMode === void 0) { signMode = signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON; }
    var authInfo = {
        signerInfos: makeSignerInfos(signers, signMode),
        fee: {
            amount: __spreadArray([], __read(feeAmount)),
            gasLimit: long_1.default.fromNumber(gasLimit),
            granter: granter,
        },
    };
    return tx_1.AuthInfo.encode(tx_1.AuthInfo.fromPartial(authInfo)).finish();
}
function signFromLedger(ledger, messages, option, registry) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, address, publicKey, signerData, pubkey, aminoTypes, msgs, chainId, accountNumber, sequence, memo, fee, signDoc, signMessage, ledgerSignature, signedTxBody, signedTxBodyEncodeObject, signedTxBodyBytes, signedGasLimit, signedAuthInfoBytes, txRaw;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ledger.getAddressAndPublicKey()];
                case 1:
                    _a = _b.sent(), address = _a.address, publicKey = _a.publicKey;
                    return [4 /*yield*/, FirmaUtil_1.FirmaUtil.getSignerDataForLedger(address)];
                case 2:
                    signerData = _b.sent();
                    pubkey = proto_signing_1.encodePubkey(encoding_2.encodeSecp256k1Pubkey(publicKey));
                    aminoTypes = new aminotypes_1.AminoTypes({});
                    msgs = messages.map(function (msg) { return aminoTypes.toAmino(msg); });
                    chainId = signerData.chain_id;
                    accountNumber = Number.parseInt(signerData.account_number);
                    sequence = Number.parseInt(signerData.sequence);
                    memo = option.memo;
                    fee = { amount: option.fee.amount, gas: option.fee.gas };
                    signDoc = signdoc_2.makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence);
                    signMessage = signdoc_1.serializeSignDoc(signDoc);
                    return [4 /*yield*/, ledger.sign(encoding_3.fromUtf8(signMessage))];
                case 3:
                    ledgerSignature = _b.sent();
                    ;
                    signedTxBody = {
                        messages: signDoc.msgs.map(function (msg) { return aminoTypes.fromAmino(msg); }),
                        memo: memo,
                    };
                    signedTxBodyEncodeObject = {
                        typeUrl: "/cosmos.tx.v1beta1.TxBody",
                        value: signedTxBody,
                    };
                    signedTxBodyBytes = registry.encode(signedTxBodyEncodeObject);
                    signedGasLimit = math_1.Int53.fromString(option.fee.gas).toNumber();
                    signedAuthInfoBytes = makeAuthInfoBytes([{ pubkey: pubkey, sequence: sequence }], option.fee.amount, signedGasLimit, option.fee.granter, signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON);
                    txRaw = tx_2.TxRaw.fromPartial({
                        bodyBytes: signedTxBodyBytes,
                        authInfoBytes: signedAuthInfoBytes,
                        signatures: [encoding_1.fromBase64(Buffer.from(ledgerSignature).toString('base64'))],
                    });
                    return [2 /*return*/, txRaw];
            }
        });
    });
}
exports.signFromLedger = signFromLedger;
